import {useDispatch, useSelector} from 'react-redux'
import {KTSVG} from '../../../_metronic/helpers'
import {getDocumentState, loadDocuments} from '../../redux/documentSlice'
import BasePopup, {PopupProvides} from '../common/popup/BasePopup'
import FileUploadForm from './FileUploadForm'
import {getAdminState, setAdminSelectedCompany} from '../../redux/adminSlice'
import {GetAdminCompanyRequest, AdminPanelCompanyDetailDTOApiData} from '../../api/data-contracts'
import {Api_Admin_GetCompany} from '../../apiClient/apiClient'
import {setIsLoading, postRequestAsync} from '../../redux/commonSlice'
import {getUserState} from '../../redux/userSlice'
import {UserTypeEnum} from '../../apiClient/enums'

function FileUploadButton() {
  const documentState = useSelector(getDocumentState)
  const adminState = useSelector(getAdminState)
  const userState = useSelector(getUserState)
  const dispatch = useDispatch()

  const loadCompanyData = async () => {
    const body: GetAdminCompanyRequest = {
      companyGuidId: adminState?.company?.company?.guid ?? '',
    }
    dispatch(setIsLoading(true))
    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_GetCompany,
        body: body,
      })
    )
      .unwrap()
      .then(async function (response: AdminPanelCompanyDetailDTOApiData) {
        dispatch(setAdminSelectedCompany(response.data))
        dispatch(setIsLoading(false))
      })
  }

  return (
    <div className=''>
      <BasePopup
        title='DOKUMAN_YUKLE'
        size='lg'
        modalOpener={
          <button type='button' className='btn btn-flex btn-primary'>
            <KTSVG
              path='/media/icons/duotune/files/fil018.svg'
              className='svg-icon-muted svg-icon-x'
            />
            {documentState.selectedFolder?.name} Yükle
          </button>
        }
      >
        {(providers: PopupProvides) => {
          return (
            <FileUploadForm
              handleClose={async () => {
                await dispatch<any>(loadDocuments())
                if (userState.data?.roleId !== UserTypeEnum.Müşteri) {
                  await loadCompanyData()
                }
                providers.handleClose()
              }}
              documentTypeId={documentState.selectedFolder?.id ?? 0}
              companyGuidId={adminState?.company?.company?.guid ?? ''}
            />
          )
        }}
      </BasePopup>
    </div>
  )
}

export default FileUploadButton
